import { ICategoryPageMatch } from "@faire/deprecated-retailer-visitor-shared/categories/ICategoryPageMatch";
import { buildCategoryNavigationPath } from "@faire/deprecated-retailer-visitor-shared/categories/navigationPath";
import { isNotUndefined } from "@faire/typescript";
import { DisplayPageType } from "@faire/web-api--source/indigofair/data/DisplayPageType";
import { route as c1Route } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId";
import { route as c2Route } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId/subcategory/c2CategoryUrlId";
import { route as c3Route } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId/subcategory/c2CategoryUrlId/c3CategoryUrlId";
import { route as c4Route } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId/subcategory/c2CategoryUrlId/c3CategoryUrlId/c4CategoryUrlId";
import { route as c5Route } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId/subcategory/c2CategoryUrlId/c3CategoryUrlId/c4CategoryUrlId/c5CategoryUrlId";
import { route as c6Route } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId/subcategory/c2CategoryUrlId/c3CategoryUrlId/c4CategoryUrlId/c5CategoryUrlId/c6CategoryUrlId";
import qs from "query-string";
import { matchPath } from "react-router-dom";

interface CommonQueryParams {
  refF?: string;
  refC?: string;
  sortingHint?: string;
  refS?: string;
}

export const getQueryParamsForSurface = (
  display_page: keyof typeof DisplayPageType,
  pathname: string,
  search: string
): CommonQueryParams => {
  const queryParams: CommonQueryParams = {};

  if (display_page === DisplayPageType.CATEGORY_PAGE) {
    const match =
      matchPath(pathname, {
        path: c1Route,
        exact: true,
        strict: false,
      }) ||
      matchPath(pathname, {
        path: c2Route,
        exact: true,
        strict: false,
      }) ||
      matchPath(pathname, {
        path: c3Route,
        exact: true,
        strict: false,
      }) ||
      matchPath(pathname, {
        path: c4Route,
        exact: true,
        strict: false,
      }) ||
      matchPath(pathname, {
        path: c5Route,
        exact: true,
        strict: false,
      }) ||
      matchPath(pathname, {
        path: c6Route,
        exact: true,
        strict: false,
      });
    if (!match) {
      return queryParams;
    }
    queryParams.refF = qs.parse(search).filters?.toString();
    const {
      c1CategoryUrlId,
      c2CategoryUrlId,
      c3CategoryUrlId,
      c4CategoryUrlId,
      c5CategoryUrlId,
      c6CategoryUrlId,
      c1SuppliersUrlId,
    } = match.params as ICategoryPageMatch;
    const categoryUrlIds = [
      c1CategoryUrlId ?? c1SuppliersUrlId,
      c2CategoryUrlId,
      c3CategoryUrlId,
      c4CategoryUrlId,
      c5CategoryUrlId,
      c6CategoryUrlId,
    ].filter(isNotUndefined);
    if (categoryUrlIds.length > 0) {
      queryParams.refC = buildCategoryNavigationPath(categoryUrlIds);
    }
    queryParams.sortingHint = "true";
  }
  if (display_page === DisplayPageType.SEARCH_PAGE) {
    queryParams.refS = qs.parse(search).q?.toString();
  }
  return queryParams;
};
